import { apiModels } from '@spo/services/api';
import { PatchApiSpoModelsBodyUpdateModelMassEditItem } from '@spo/types';
import { useQuery } from '@tanstack/react-query';

export const useModelsMassEdit = (
  updateModelMassEdit: PatchApiSpoModelsBodyUpdateModelMassEditItem[],
) => {
  return useQuery({
    queryKey: ['useModelsMassEdit', updateModelMassEdit],
    queryFn: () => apiModels.updateModels({ updateModelMassEdit }),
    enabled: updateModelMassEdit.length > 0,
  });
};
